// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import FilterPage from '@/pages/search/components/_PCSFilterPage.vue'
import i18n from '@/lang/i18n.ts'

hybridPage()

const app = createApp({
	name: 'SearchPage',
	components: {
		FilterPage,
	},
	setup() {},
})

app.use(i18n)
app.mount('#bsMain')
